module.exports = __webpack_public_path__ + "static/media/Circo2024_17.e6945669.webp";